import { useQuasar } from 'quasar'
import logger from 'src/services/logger'

let device = null

export function useDevice($quasar = null) {
  if (device !== null) {
    return device
  }

  const $q = $quasar ?? useQuasar()

  const userAgent = ($q.platform.userAgent || '').toLowerCase()
  const isNextMobileAppVersion = userAgent.includes('aptelecare-app/2.0 biometry/2.0')
  const isIos = $q.platform.is.ios
  const isAndroid = $q.platform.is.android

  const isMobileApp = (
    (userAgent.includes('wv') && isAndroid) ||
    (!userAgent.includes('safari') && isIos)
  ) || isNextMobileAppVersion

  function isNativeCallAvailable() {
    return (
      isNextMobileAppVersion &&
      typeof window !== 'undefined' &&
      window.jsBridge &&
      typeof window.jsBridge.callNative === 'function'
    )
  }

  async function callNative(methodName, params = {}, callback = null) {
    if (!isNativeCallAvailable()) {
      const msg = `[useDevice] Unable to call “${methodName}”: the native bridge is missing.`
      logger.warn(msg)
      return Promise.reject(new Error(msg))
    }

    try {
      return await window.jsBridge.callNative(methodName, params, callback)
    } catch (error) {
      logger.error(`[useDevice] Error during native call “${methodName}”:`, error)
      throw error
    }
  }

  device = {
    isIos,
    isAndroid,
    isMobileApp,
    isNextMobileAppVersion,
    isNativeCallAvailable,
    callNative
  }

  return device
}
